import React from 'react';
import { Tooltip, TooltipProps } from '@mui/material';
import { styled } from '@mui/material/styles';

export const StyledTooltip = styled(({ className, ...props }: TooltipProps) => (
  <Tooltip {...props} classes={{ popper: className }} />
))(({ theme, sx }) => ({
  [`& .MuiTooltip-tooltip`]: {
    backgroundColor: '#ffffff',
    color: '#354052',
    fontSize: '12px',
    fontFamily: 'Rubik, sans-serif',
    fontWeight: 'bold',
    boxShadow: '0 0 2px rgba(0,0,0,0.5)',
    ...(sx && sx),
  },
}));
